import React from 'react';

function FairnessButton({ text, handleClick, isDisabled = false }) {
  return (
    <div className='cpt-button-container'>
      <div className='cpt-button-inner'>
        <button onClick={handleClick} className={`cpt-cal-bt-b ${isDisabled ? 'disabled' : ''}`}>
          <span className='cpt-cal-bt-b-txt'>{text}</span>
        </button>
      </div>
    </div>
  );
}

export default FairnessButton;
